import { render, staticRenderFns } from "./SetupMandate.vue?vue&type=template&id=f5284b4e"
import script from "./SetupMandate.vue?vue&type=script&lang=js"
export * from "./SetupMandate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports